import { render, staticRenderFns } from "./GetGood.vue?vue&type=template&id=4e719072&"
import script from "./GetGood.vue?vue&type=script&lang=js&"
export * from "./GetGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports